import { render, staticRenderFns } from "./StudentsView.vue?vue&type=template&id=1c809c88&scoped=true&"
import script from "./StudentsView.vue?vue&type=script&lang=ts&"
export * from "./StudentsView.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=1c809c88&prod&scoped=true&lang=css&"
import style1 from "./StudentsView.vue?vue&type=style&index=1&id=1c809c88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c809c88",
  null
  
)

export default component.exports